import {media} from '../helpers/media';

export class MobileMenu {
  constructor(options) {
    this.$menuToggle = $(options.menuToggle);

    this.bodyElement = 'body';
    this.mobileMenu = '.js-mobile-menu';
    this.mobileIcon = '.js-mobile-icon';

    this.ACTIVE_CLASS = 'is-active';
    this.VISIBLE_CLASS = 'is-visible';
    this.DISABLE_SCROLL_CLASS = 'u-no-scroll';

    this.menuOpened = false;
    this.toggleMobile = this.toggleMobile.bind(this);
    this.resetMobileMenu = this.resetMobileMenu.bind(this);
  }

  toggleMobile(e) {

    const $curentElement = $(e.currentTarget);

    this.menuOpened = !this.menuOpened;
    if (window.innerWidth <= media.tablet) {
      $curentElement.parents(this.bodyElement).toggleClass(this.DISABLE_SCROLL_CLASS);
      $(this.mobileMenu).toggleClass(this.VISIBLE_CLASS);
      $curentElement.find(this.mobileIcon).toggleClass(this.ACTIVE_CLASS);
    }
    return this.menuOpened;
  }

  resetMobileMenu() {
    if (window.innerWidth >= media.tablet) {
      $(this.bodyElement).removeClass(this.DISABLE_SCROLL_CLASS);
      $(this.mobileMenu).removeClass(this.VISIBLE_CLASS);
      $(this.mobileIcon).removeClass(this.ACTIVE_CLASS);
    }
  }
}
